export function getApiUrl (env, location) {
  // shortcut: force api url set via. env. var.
  if (env.VUE_APP_API_URL) {
    return env.VUE_APP_API_URL
  }

  // default
  // "https://booksy.com" > "https://{country}.booksy.com/api"
  // "https://pro3.t1.booksy.pm" > "https://{country}.pro3.t1.booksy.pm/api"
  // ...
  return [
    location.origin
      .replace('://', '://{country}.')
      .replace(/\/+$/, ''),
    'api',
  ].join('/')
}
